<template>
    <div class="card border-secondary dex">
        <div class="row justify-content-between p-1">
            <div class="col-6">
              <button type="button" class="btn btn-secondary btn-sm btn-dark"
                      v-on:click="addBattle1">L.
              </button>
              <span> vs </span>
             <button type="button" class="btn btn-secondary btn-sm btn-dark"
                     v-on:click="addBattle2">R.
             </button>
            </div>
            <div class="col-6 text-right">
              <button type="button" class="btn btn-secondary btn-sm btn-dark mr-1"
                      v-on:click="minmax_lise">{{ showBody ? "_": "&#9633;" }}
              </button>
                <button type="button" class="btn btn-secondary btn-sm btn-dark"
                        v-on:click="xDelete">X
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-11">
                <h5 class="text-center card-title">
                    <input class="form-control-sm col-2 text-center light_border card-title" style="max-width: 3rem;"
                           id="id-input" v-model="id"/>
                    {{name}}
                    <h6 class="card-subtitle text-muted"><span>{{types[0]}}</span> <span>{{types[1]}}</span></h6>
                </h5>
            </div>
        </div>
        <div v-if="showBody" class="card-body" style="margin: -5px;">
            <div class="row d-block d-sm-none" style="margin-top: -25px;margin-bottom: 0px;">
              <b-tabs>
                <b-tab title="Pokemon">
                  <form>
                    <div class="form-row">
                      <div class="offset-3 col-6 text-center">
                        <label for="level-input" class="">Level
                          <input class="form-control form-control-sm" id="level-input" type="number" min="0"
                                 step="0.5" max="45"
                                 v-model="level"/></label>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="form-row">
                        <div class="col-4 text-center">
                          <label for="att-input">Att
                            <input class="form-control form-control-sm" id="att-input" type="number" min="0"
                                   max="15"
                                   v-model="ivs[0]"/></label>
                        </div>
                        <div class="col-4 text-center">
                          <label for="def-input">Def
                            <input class="form-control form-control-sm" id="def-input" type="number" min="0"
                                   max="15"
                                   v-model="ivs[1]"/></label>
                        </div>
                        <div class="col-4 text-center">
                          <label for="sta-input">Sta
                            <input class="form-control form-control-sm" id="sta-input" type="number" min="0"
                                   max="15"
                                   v-model="ivs[2]"/></label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="form-row">
                        <div class="col-12 text-center">
                          <label for="fast-input">Fast
                            <v-select id="fast-input" class="move-select" label="name" v-model="move1"
                                      :options="getFastMoves()"/>
                          </label>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-12 text-center">
                          <label for="ch1-input">Char. 1
                            <v-select id="ch1-input" class="move-select" label="name" v-model="move2"
                                      :options="getChargedMoves()"/>
                          </label>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-12 text-center">
                          <label for="ch2-input">Char. 2
                            <v-select id="ch2-input" class="move-select" label="name" v-model="move3"
                                      :options="getChargedMoves()"/>
                            <!--                                        todo power/energy input customs-->
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </b-tab>
                <b-tab title="Hodnocení">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col d-flex justify-content-center">
                        <strong>Max CP {{this.getMaxCp}}/{{this.getPerfectMaxCp}}</strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col d-flex justify-content-center">
                        <strong>CP {{this.getCp}}</strong>
                      </div>
                      <div class="col d-flex justify-content-center">
                        <strong>Hp {{this.getHp}}</strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        Att
                        {{Math.round(this.getStats[0])}}
                      </div>
                      <div class="col">
                        Def
                        {{Math.round(this.getStats[1])}}
                      </div>
                      <div class="col">
                        Sta
                        {{Math.round(this.getStats[2])}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        Total stats: {{Math.floor(this.getTotal)}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <br/>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col d-flex">
                        Perfect IV CP: {{this.getPerfectCp}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col d-flex">
                        Zero IV CP: {{this.getZeroCp}}
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
              <div class="row d-none d-sm-flex" style="margin: -25px;margin-bottom: 0px;">
                <div class="col-6">
                    <form>
                        <div class="form-row">
                            <div class="offset-3 col-6 text-center">
                                <label for="level-input" class="">Level
                                    <input class="form-control form-control-sm" id="level-input" type="number" min="0"
                                           step="0.5" max="45"
                                           v-model="level"/></label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="form-row">
                                <div class="col-4 text-center">
                                    <label for="att-input">Att
                                        <input class="form-control form-control-sm" id="att-input" type="number" min="0"
                                               max="15"
                                               v-model="ivs[0]"/></label>
                                </div>
                                <div class="col-4 text-center">
                                    <label for="def-input">Def
                                        <input class="form-control form-control-sm" id="def-input" type="number" min="0"
                                               max="15"
                                               v-model="ivs[1]"/></label>
                                </div>
                                <div class="col-4 text-center">
                                    <label for="sta-input">Sta
                                        <input class="form-control form-control-sm" id="sta-input" type="number" min="0"
                                               max="15"
                                               v-model="ivs[2]"/></label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="form-row">
                                <div class="col-12 text-center">
                                    <label for="fast-input">Fast
                                        <v-select id="fast-input" class="move-select" label="name" v-model="move1"
                                                  :options="getFastMoves()"/>
                                    </label>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 text-center">
                                    <label for="ch1-input">Char. 1
                                        <v-select id="ch1-input" class="move-select" label="name" v-model="move2"
                                                  :options="getChargedMoves()"/>
                                    </label>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 text-center">
                                    <label for="ch2-input">Char. 2
                                        <v-select id="ch2-input" class="move-select" label="name" v-model="move3"
                                                  :options="getChargedMoves()"/>
                                        <!--                                        todo power/energy input customs-->
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-6">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col d-flex justify-content-center">
                                <strong>Max CP {{this.getMaxCp}}/{{this.getPerfectMaxCp}}</strong>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col d-flex justify-content-center">
                                <strong>CP {{this.getCp}}</strong>
                            </div>
                            <div class="col d-flex justify-content-center">
                                <strong>Hp {{this.getHp}}</strong>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                Att
                                {{Math.round(this.getStats[0])}}
                            </div>
                            <div class="col">
                                Def
                                {{Math.round(this.getStats[1])}}
                            </div>
                            <div class="col">
                                Sta
                                {{Math.round(this.getStats[2])}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                Total stats: {{Math.floor(this.getTotal)}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <br/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col d-flex">
                                Perfect IV CP: {{this.getPerfectCp}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col d-flex">
                                Zero IV CP: {{this.getZeroCp}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex justify-content-center">
                    <button v-on:click="findBestStats(1500)" class="btn btn-dark">1500</button>
                    <button v-on:click="findBestStats(2500)" class="btn btn-dark">2500</button>
                    <button v-on:click="findBestStats(10000)" class="btn btn-dark">Unlimited</button>
                    <button v-if="best" v-on:click="hideBest()" class="btn btn-dark">Close</button>
                </div>
            </div>
            <StatInfo :stats_array="best" :currStats="getStats"/>
        </div>
    </div>
</template>

<script>
    import {pokemon_data, cpm, types, fast_moves, charged_moves, current_moves} from "../../helpers/pokemon_data.js";
    import vSelect from "vue-select";
    import {stats} from "../../helpers/pokemon_calc";
    import {zeroPad} from "../../helpers/utils";
    import {c_charged_moves, c_fast_moves} from "../../helpers/pokemon_data.js";
    import StatInfo from "./battle/StatInfo";
    import {downloadObjectAsJson} from "../../helpers/downloadData";
    import {BTab, BTabs} from "bootstrap-vue";
    // eslint-disable-line

    export default {
        name: "PokemonGoStatCalc",
        props: ['pokemonId', 'onDelete', 'uuid', 'onEdit', 'poke', 'addBattler', 'pvp', 'updateBattler'],
        components: {StatInfo, vSelect,BTabs,BTab},
        data: function () {
            let level = "20";
            if (this.poke.level !== undefined) {
                level = this.poke.level
            }
            let ivs = ["10", "10", "10"];
            if (this.poke.ivs !== undefined) {
                ivs = this.poke.ivs
            }
            let moves = {
                '0': {name: '', power: '', energy_delta: ''},
                '1': {name: '', power: '', energy_delta: ''},
                '2': {name: '', power: '', energy_delta: ''},
            };
            if (this.poke.moves !== undefined) {
                moves['0'] = this.poke.moves['0'];
                moves['1'] = this.poke.moves['1'];
                moves['2'] = this.poke.moves['2'];
            }
            return {
                id: this.pokemonId || "1",
                // name: "",
                level: level,
                ivs: ivs,
                move1: moves['0'],
                move2: moves['1'],
                move3: moves['2'],
                best:null,
                showBody:true
                // fast_moves:this.getFastMoves(),
                // charged_moves:this.getChargedMoves(),
                // moves: moves
            }
        },
        methods: {
            xDelete: function () {
                this.onDelete(this.uuid);
            },
            xEdit: function () {
                debugger // eslint-disable-line
                this.onEdit(this.uuid, {id: this.id, ivs: this.ivs, level: this.level, moves: this.moves});
            },
            minmax_lise:function (){
              this.showBody=!this.showBody;
            },
            calcCp: function (id, ivs, level) {
                let poke = pokemon_data[id][5];
                let l = 2 * level;
                let cp_mult = cpm[l - 1];
                let sta = poke[0] + ivs[2];
                let att = poke[1] + ivs[0];
                let def = poke[2] + ivs[1];
                let cp = (att * Math.pow(def, 0.5) * Math.pow(sta, 0.5) * Math.pow(cp_mult, 2)) / 10;
                return cp
            },
            calcDamage: function (att, def, power, multipliers) {
                return Math.floor(0.5 * power * (att / def) * multipliers) + 1
            },
            addBattle1: function () {
                this.addBattler(1, this.uuid)
            },
            addBattle2: function () {
                this.addBattler(2, this.uuid)
            },
            getFastMoves: function () {
                let possible_moves = current_moves
                    .filter((move_set) => move_set.pokemon_name === this.name)
                    .map((move_set) => move_set.fast_moves);
                possible_moves = [...new Set([].concat(...possible_moves))];
                // possible_moves.unshift({name:'none'});
                // return [...new Set([].concat(...possible_moves))]
                // let moves = this.pvp ? c_fast_moves : fast_moves;
                let moves = fast_moves.filter((move) => possible_moves.indexOf(move.name) >= 0);

                if (this.pvp) {
                    return moves.map(move => {
                        let cmove = c_fast_moves.find((mo) => mo.move_id === move.move_id);
                        if (cmove) {
                            //debugger // eslint-disable-line
                            // console.log('cmove');
                            // console.log(move);
                            // console.log(cmove);
                            // console.log( {...move, ...cmove});
                            return {...move, ...cmove};
                        }
                        //debugger // eslint-disable-line
                        // console.log('move');
                        // console.log(move);
                        return moves;
                    });
                } else {
                    return moves;
                }

            },
            getChargedMoves: function () {
                let possible_moves = current_moves
                    .filter((move_set) => move_set.pokemon_name === this.name)
                    .map((move_set) => move_set.charged_moves);
                /* possible_moves.unshift({
                //         duration: 2000,
                //         energy_delta: -33,
                //         move_id: 322,
                //         name: "Frustration",
                //         power: 10,
                //         stamina_loss_scaler: "0.01",
                //         type: "Normal"
                //     });
                // possible_moves.unshift({
                //     duration: 700,
                //     energy_delta: -33,
                //     move_id: 323,
                //     name: "Return",
                //     power: 35,
                //     stamina_loss_scaler: "0.01",
                //     type: "Normal"
                // });*/
                possible_moves = [...new Set([].concat(...possible_moves))];

                let moves = charged_moves.filter((move) => move.name == "Frustration" || move.name == "Return" || possible_moves.indexOf(move.name) >= 0);

                if (this.pvp) {
                    return moves.map(move => {
                        let cmove = c_charged_moves.find((mo) => mo.move_id === move.move_id);
                        if (cmove) {
                            return {...move, ...cmove};
                        }
                        return moves;
                    });
                } else {
                    return moves;
                }

                //
            },
            findBestStats: function (targetCp, count=20) {
                    let results = {};
                if (results[this.id] === undefined) {
                    results[this.id] = {};
                    if (results[this.id][targetCp] === undefined) {
                        // let results = {};
                        for (let l = 40; l > 1; l-=0.5) {// eslint-disable-line
                            for (let a = 15; a > 1; a--) {// eslint-disable-line
                                for (let d = 15; d > 1; d--) {// eslint-disable-line
                                    for (let s = 15; s > 1; s--) {// eslint-disable-line
                                        if (results[this.id][targetCp] === null || results[this.id][targetCp] === undefined) {
                                            results[this.id][targetCp] = []
                                        }
                                        if(targetCp==10000 &&results[this.id][targetCp].length > count){
                                            // debugger // eslint-disable-line
                                            break;
                                        }
                                        let cp = this.calcCp(this.id, [a, d, s], l);
                                        if((cp > targetCp || (cp < 1000 && targetCp!=10000))&& results[this.id][targetCp].length!=0){//|| cp < (targetCp*0.7)
                                            continue;
                                        }
                                        let currStats = stats(this.id, l, [a, d, s]);
                                        let product = currStats[0] * currStats[1] * currStats[2];
                                        if((targetCp == 1500 && product < 1300 || targetCp == 2500 && product < 3000)&& results[this.id][targetCp].length!=0){//|| cp < (targetCp*0.7)
                                            continue;
                                        }
                                        let sum = Math.floor(currStats[0]) + Math.floor(currStats[1]) + Math.floor(currStats[2]);
                                        // debugger // eslint-disable-line
                                        if (cp <= targetCp)
                                            results[this.id][targetCp].push({
                                                cp: Math.floor(cp),
                                                IV: [a, d, s],
                                                lvl: l,
                                                STAT: currStats.map((e)=>Math.round(e)),
                                                totalStat: Math.round((sum + Number.EPSILON) * 100) / 100 ,
                                                productStat: Math.round((product/1000 + Number.EPSILON) * 100) / 100
                                            });
                                    }
                                }
                            }
                        }
                        // debugger // eslint-disable-line
                        results[this.id][targetCp].sort((a, b) => {
                            let x = [zeroPad(a.productStat,7),zeroPad(a.totalStat,4)].toString();//a.cp,
                            let y = [zeroPad(b.productStat,7),zeroPad(b.totalStat,4)].toString();//b.cp,
                            // debugger // eslint-disable-line
                            if (x < y) {
                                return 1;
                            }
                            if (x > y) {
                                return -1;
                            }
                            return 0;
                        });
                    }
                }
                this.best=results[this.id][targetCp].slice(0,count);
                // downloadObjectAsJson(results,this.id+"_"+targetCp+".json");
                return results[this.id][targetCp]
            },
            hideBest:function () {
                this.best = null
            }
        },
        computed: {
            pokemon: function () {
                // debugger // eslint-disable-line
                return pokemon_data[this.id.toString()]
            },
            types: function () {
                return this.pokemon[4].map(t => types[t])
            },
            name: function () {
                return this.pokemon[0]
            },
            moves: function () {
                return {'0': this.move1, '1': this.move2, '2': this.move3}
            },
            getCp: function () {
                let poke = this.pokemon[5];
                let l = 2 * parseFloat(this.level);
                let cp_mult = cpm[l - 1];
                let sta = poke[0] + parseInt(this.ivs[2]);
                let att = poke[1] + parseInt(this.ivs[0]);
                let def = poke[2] + parseInt(this.ivs[1]);
                let cp = (att * Math.pow(def, 0.5) * Math.pow(sta, 0.5) * Math.pow(cp_mult, 2)) / 10;
                return Math.max(10, Math.floor(cp));
            },
            getPerfectCp: function () {
                let cp = this.calcCp(this.id, [15, 15, 15], parseFloat(this.level));//((att * Math.pow(def, 0.5) * Math.pow(sta, 0.5) * Math.pow(cp_mult, 2)) / 10;
                return Math.max(10, Math.floor(cp));
            },
            getZeroCp: function () {
                let cp = this.calcCp(this.id, [0, 0, 0], parseFloat(this.level));//((att * Math.pow(def, 0.5) * Math.pow(sta, 0.5) * Math.pow(cp_mult, 2)) / 10;
                return Math.max(10, Math.floor(cp));
            },
            getMaxCp: function () {
                let cp = this.calcCp(this.id, [parseInt(this.ivs[0]),parseInt(this.ivs[1]),parseInt(this.ivs[2])], 40);//((att * Math.pow(def, 0.5) * Math.pow(sta, 0.5) * Math.pow(cp_mult, 2)) / 10;
                return Math.max(10, Math.floor(cp));
            },
            getPerfectMaxCp: function () {
                let cp = this.calcCp(this.id, [15, 15, 15], 40);//((att * Math.pow(def, 0.5) * Math.pow(sta, 0.5) * Math.pow(cp_mult, 2)) / 10;
                return Math.max(10, Math.floor(cp));
            },
            getTotal: function () {
                return this.getStats[0] + this.getStats[1] + this.getStats[2];
            },
            getHp: function () {
                // debugger // eslint-disable-line
                let poke = this.pokemon[5];
                let l = 2 * parseFloat(this.level);
                return Math.max(10, (Math.floor((poke[0] + parseInt(this.ivs[2])) * cpm[l - 1])));
            },
            getStats: function () {
                return stats(this.id, this.level, this.ivs)
            },
            params: function () {
                return {id: this.id, ivs: this.ivs, level: this.level, moves: this.moves}
            },
        },
        watch: {
            pokemon: function () {
                this.onEdit(this.uuid, this.params);
            },
            level: function () {
                if (this.level > 45) {
                    this.level = 45
                }
                if (this.level < 0) {
                    this.level = 1
                }
                this.onEdit(this.uuid, this.params);
            },
            ivs: function () {
                for (let i = 0; i < 3; i++) {
                    if (parseInt(this.ivs[i]) > 15) {
                        this.ivs[i] = 15
                    }
                    if (parseInt(this.ivs[i]) < 0) {
                        this.ivs[i] = 1
                    }
                }
                this.onEdit(this.uuid, this.params);
            },
            moves: function () {
                // debugger // eslint-disable-line
                this.onEdit(this.uuid, this.params);
                this.updateBattler();
            },
        }
    }
</script>

<style scoped>
    .dex {
        min-width: 20rem;
        max-width: 26rem;
    }

    .no_border {
        border: 0px #00000000 solid;
    }

    .light_border {
        border: 1px #b0b7be solid;
    }

    input[type=number] {
        margin: 0;
        -webkit-appearance: none;
        -moz-appearance: textfield;
        text-align: center;
    }

    .move-select {
        min-width: 150px;
        /*width: 160px;*/
        max-width: 175px;

    }
</style>